import { Charge } from '@/api/fee/charge';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from '@/components/ui/tooltip';
import { ColumnDef } from '@tanstack/react-table';
import { ArrowUpDown, Download, Eye } from 'lucide-react';
import { Link } from 'react-router';

import { UpdateCharge } from './sheet-update';

export const columns: ColumnDef<Charge>[] = [
	{
		accessorKey: 'id',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Charge Id
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => <div className="font-medium">{row.original.id}</div>,
	},
	{
		accessorKey: 'chargeName',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Charge Name
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => {
			return (
				<div className="whitespace-nowrap font-medium">
					{row.original.chargeName}
				</div>
			);
		},
	},
	{
		accessorKey: 'transSummaryField',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				TransSummary Field
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => {
			return (
				<div className="whitespace-nowrap font-medium">
					{row.original.transSummaryField}
				</div>
			);
		},
	},
	{
		accessorKey: 'isTax',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Tax
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => {
			return (
				<div className="flex justify-center">
					<Checkbox checked={!!row.original.isTax} disabled />
				</div>
			);
		},
	},
	{
		accessorKey: 'isExpired',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Expired
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => {
			return (
				<div className="flex justify-center">
					<Checkbox checked={!!row.original.isExpired} disabled />
				</div>
			);
		},
	},
	{
		id: 'actions',
		cell: ({ row }) => (
			<div>
				<TooltipProvider>
					<Tooltip>
						<TooltipTrigger asChild>
							{row.original.isTax === true ? (
								<Button className="m-auto" variant="ghost" disabled>
									<Eye size={16} />
								</Button>
							) : (
								<Link
									to={`/fee/state-mappings/${row.original.id}?chargeName=${row.original.chargeName}`}
								>
									<Button className="m-auto" variant="ghost">
										<Eye size={16} />
									</Button>
								</Link>
							)}
						</TooltipTrigger>
						<TooltipContent>
							<p>View State Mappings</p>
						</TooltipContent>
					</Tooltip>
				</TooltipProvider>

				<UpdateCharge charge={row.original} />
			</div>
		),
	},
];
